import { declareVueComponent, declareVrunComponent } from '/vodalys/vvuejs'

declareVueComponent('Question24ModerateQuestion',() => import('./Question24ModerateQuestion.vue'));
declareVueComponent('Question24ModerateQuestions',() => import('./Question24ModerateQuestions.vue'));

declareVrunComponent('question24Moderate.vrun.component', () => import('./Question24Moderate.vue'));